import React, { Component } from "react";
import { createTabHeaderTemplate } from "../../../components/ui";
import { toastService } from "../../../services/toastService";
import { TabPanel, TabView } from "primereact/tabview";
import Vendors from "./Vendors";
import VendorCategories from "./VendorCategories";
import { merchantVendorApiService } from "../../../services/api/merchants/MerchantVendorApiService";
import Loader from "../../../components/Loader";

interface MerchantVendorsProps {
    merchantId: number;
}

interface MerchantVendorsState {
    activeTabIndex: number;
    isLoading: boolean;
    syncMerchantVendors: boolean;
}

export default class MerchantVendors extends Component<MerchantVendorsProps, MerchantVendorsState> {
    constructor(props: MerchantVendorsProps | Readonly<MerchantVendorsProps>) {
        super(props);

        this.state = {
            activeTabIndex: 0,
            isLoading: true,
            syncMerchantVendors: false,
        };
    }

    async componentDidMount() {
        await this.syncMerchantVendor();
    }

    syncMerchantVendor = async () => {
        if (this.props.merchantId) {
            await this.syncMerchantVendorLoad();
        }
        this.setState({ isLoading: false });
    };

    syncMerchantVendorLoad = async () => {
        const vendors = await merchantVendorApiService.syncMerchantVendors(this.props.merchantId);
        if (!vendors.success) {
            toastService.error(vendors.message);
            this.setState({ isLoading: false });
            return;
        }
        this.setState((prevState) => ({
            syncMerchantVendors: true,
        }));
    };

    handleSyncClick = () => {
        this.setState((prevState) => ({
            syncMerchantVendors: true,
        }));
    };

    render() {
        if (this.state.isLoading) {
            return <Loader />;
        }

        if (!this.state.syncMerchantVendors) {
            return (
                <div className="text-center py-8">
                    <p>Data syncing failed.</p>
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            this.handleSyncClick();
                        }}
                        className="text-primary-600 hover:text-primary-700 dark:text-primary-400"
                    >
                        Load Old Data
                    </a>
                </div>
            );
        }

        return (
            <div>
                        <TabView
                            activeIndex={this.state.activeTabIndex}
                            onTabChange={(e) => {
                                this.setState({ activeTabIndex: e.index });
                            }}
                            pt={{
                                nav: {
                                    className: "gap-1",
                                },
                            }}
                        >
                            <TabPanel pt={{ content: { className: "pt-0 px-5 pb-5" } }} headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)} header="Vendors">
                                <Vendors merchantId={this.props.merchantId} />
                            </TabPanel>

                            <TabPanel
                                pt={{ content: { className: "pt-0 px-5 pb-5" } }}
                                headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)}
                                header="Vendors Category"
                            >
                                <VendorCategories merchantId={this.props.merchantId} />
                            </TabPanel>
                        </TabView>
            </div>
        );
    }
}
